<template>
  <div
    :class="{
      'col-span-12 flex h-full rounded-t-5px border border-b-5px border-www-color-neutral-light border-b-www-color-primary-lighter bg-www-color-white hover:border-www-color-neutral-medium-light': true,
      'col-span-12 grid grid-cols-12 lg:rounded-l-5px': orientation === 'horizontal',
      'flex-col rounded-t-5px md:col-span-6 lg:col-span-4': orientation === 'vertical',
    }"
  >
    <div
      :class="{
        'img-contianer': true,
        'col-span-12 lg:col-span-5': orientation === 'horizontal',
        'h-52': orientation === 'vertical',
      }"
    >
      <img
        v-if="data?._type === 'video'"
        :src="data.wistiaVideoMetadata?.thumbnailUrl ?? ''"
        alt="icon"
        :class="{
          'h-full w-full rounded-t-5px object-cover': true,
        }"
      />
      <PtcPicture
        v-else
        provider="sanity"
        :src="data?.cardImage?.asset?._ref ?? ''"
        :quality="75"
        :img-attrs="{
          class: {
            'w-full h-full object-cover': true,
          },
        }"
        :modifiers="{
          crop: data?.cardImage?.crop,
          hotspot: data?.cardImage?.hotspot,
          w: 600,
        }"
        :alt="resolvedImage?.altText || 'manual card image'"
        :class="{}"
      />
    </div>
    <div
      :class="{
        'flex flex-grow flex-col px-6 pb-4 pt-8 text-www-color-neutral-medium-dark': true,
        'col-span-12 lg:col-span-7': orientation === 'horizontal',
      }"
    >
      <div
        :class="{
          'flex-grow': true,
        }"
      >
        <PTCLink
          v-if="data?.currentPathname"
          :to="`${data.currentPathname}`"
        >
          <h5
            :class="{
              'text-xl font-black text-www-color-neutral-medium-dark': true,
              'transition-all duration-300 hover:underline hover:decoration-www-color-accent-orange-light': true,
            }"
          >
            {{ data?.title }}
          </h5>
        </PTCLink>
        <p
          v-if="data?.articleDate"
          :class="{
            'my-10px text-10px text-www-color-neutral-medium-dark': true,
          }"
        >
          {{ formatDateUTC(data?.articleDate, 'MM.DD.YYYY') }}
        </p>
        <p
          :class="{
            'flex-grow text-15px leading-7 text-www-color-neutral-medium-dark lg:line-clamp-5': true,
          }"
        >
          {{ data?.description }}
        </p>
      </div>
      <PTCLink
        v-if="data?.currentPathname"
        :to="`${data.currentPathname}`"
        :class="{
          'mt-auto flex items-center gap-10px': true,
        }"
      >
        <p
          :class="{
            'py-22px font-ptc-Rajdhani text-base font-bold text-www-color-primary-lighter': true,
            'uppercase transition-all duration-300 hover:text-www-color-primary': true,
          }"
        >
          {{ data.cardButtonText || 'Learn More' }}
        </p>
        <PtcIcon
          name="ptc-arrow-white"
          alt="arrow"
          :class="{
            'text-base text-www-color-primary-lighter': true,
          }"
        />
      </PTCLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { ReferenceCard } from '~/sanity/types';
import { useRefsStore } from '~/composables/refsStore';
import PTCLink from '~/components/Atoms/PTCLink/PTCLink.vue';
import PtcPicture from '~/components/Atoms/PtcPicture/PtcPicture.vue';
import PtcIcon from '~/components/Atoms/PtcIcon/PtcIcon.vue';

const { getResolvedReferenceCard, getResolvedImage } = useRefsStore();
const props = defineProps<ReferenceCard>();
const data = await getResolvedReferenceCard(props.selectedPage?.reference?._ref);
const resolvedImage = await getResolvedImage(data.value?.cardImage?.asset?._ref);
</script>
